import { useEffect, useRef, useState } from 'react';
import { RESCUE_STATUS_LABEL, type RescueRowDto, type RescueStatus } from '@coachrex/shared';
import { useToast } from '../components/Toast';

/**
 * "Open in CRM" flow: opens the contact, marks the row "Watching…", and when the worker sees the rep act
 * (the item's status changes on the next refresh) tells the manager where it went.
 */
export function useWatching(rows: RescueRowDto[] | undefined) {
  const toast = useToast();
  const started = useRef(new Map<string, RescueStatus>());
  const [watching, setWatching] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!rows) return;
    for (const r of rows) {
      const was = started.current.get(r.id);
      if (was && r.status !== was) {
        started.current.delete(r.id);
        setWatching((w) => {
          const next = new Set(w);
          next.delete(r.id);
          return next;
        });
        toast({ text: `✓ ${r.leadName} moved to ${RESCUE_STATUS_LABEL[r.status]}. ${r.statusLine.split(' · ')[0]}.` });
      }
    }
  }, [rows, toast]);

  const watch = (r: RescueRowDto) => {
    window.open(r.crmUrl, '_blank', 'noopener');
    if (started.current.has(r.id)) return;
    started.current.set(r.id, r.status);
    setWatching((w) => new Set(w).add(r.id));
    toast({ text: `Opened ${r.leadName.split(' ')[0]} in your CRM. Coach Lex will update the status when it sees a call, text or email.` });
  };

  return { watching, watch };
}
